export default __webpack_public_path__ + "static/media/640_business06-it-web.0a29ba3c.png";